export default __webpack_public_path__ + "static/media/roboter.b3bd689e.svg";